import React, { useState, useEffect } from 'react';
import { FiMenu } from 'react-icons/fi';

import Header from './Components/Header';
import Sidebar from './Components/Sidebar';

import AboutMe from './Components/AboutMe';
import WorkHistory from './Components/WorkHistory';
import Technologies from './Components/Technologies';
import Achievements from './Components/Achievements';
import LinkedInRecommendations from './Components/LinkedInRecommendations';
import ArticlesSection from './Components/ArticlesSection';

import { applyTheme, readStoredTheme } from './theme';
import { filenameForTab } from './navFiles';

import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [theme, setTheme] = useState(() => readStoredTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const onSideBarClick = (tabIndex) => {
    setActiveTab(tabIndex);
    setIsSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((open) => !open);
  };

  const onToggleTheme = () => {
    setTheme((current) => applyTheme(current === 'dark' ? 'light' : 'dark'));
  };

  const activeFilename = filenameForTab(activeTab);

  return (
    <div className="bg-page bg-grid-subtle text-ink h-dvh w-full flex flex-col overflow-hidden">
      <Header theme={theme} onToggleTheme={onToggleTheme} />

      <button
        type="button"
        className="md:hidden p-3 bg-page border border-line text-ink fixed top-4 left-4 z-50 rounded-md"
        onClick={toggleSidebar}
        aria-label={isSidebarOpen ? 'Close explorer' : 'Open explorer'}
        aria-expanded={isSidebarOpen}
      >
        <FiMenu className="h-6 w-6" />
      </button>

      <main className="flex-1 min-h-0 grid grid-cols-1 md:grid-cols-[16rem_1fr] mx-auto w-full">
        <div
          className={`fixed top-0 left-0 h-full z-40 transition-transform transform ${
            isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } md:static md:translate-x-0 md:h-full md:min-h-0 md:overflow-y-auto bg-page border-r border-line`}
        >
          <Sidebar activeTab={activeTab} onClick={onSideBarClick} />
        </div>

        <div className="py-6 px-4 md:px-8 w-full min-w-0 min-h-0 flex flex-col flex-1">
          <div className="mb-4 border-b border-line shrink-0">
            <span className="inline-block font-mono text-sm px-3 py-2 border-b-2 border-accent text-ink">
              {activeFilename}
            </span>
          </div>
          <div className="glass-card rounded-lg p-4 md:p-6 flex-1 min-h-0 flex flex-col overflow-hidden">
            <div key={activeTab} className="fade-in flex-1 min-h-0 overflow-y-auto">
              {activeTab === 0 && <AboutMe />}
              {activeTab === 1 && <WorkHistory />}
              {activeTab === 2 && <Technologies />}
              {activeTab === 3 && <Achievements />}
              {activeTab === 4 && <LinkedInRecommendations />}
              {activeTab === 5 && <ArticlesSection />}
            </div>
          </div>
        </div>
      </main>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-slate-950/40 z-30 md:hidden"
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
}

export default App;
